import type { FaireProductEntity } from "../../entity_types/product";

export const p_fesym2df5v: FaireProductEntity = {
  token: "p_fesym2df5v",
  type: "product",
  name: "Salut Letterpress Greeting Card",
  brandToken: "b_4cdthxubt5",
  brandName: "Half Pint Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f8e1e7eb060eef9fe77de5f07a3f0044e2b34e985b3bc7ead0a3f07d6e876ffd.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Letterpress printed greeting card\n\n * Green, Red and Black ink \n * Size: 4-Bar (3.5 x 4.875") \n * Blank on the inside \n * Printed on natural white cotton paper \n * Comes with 30% post-consumer waste Kraft envelope \nShips USPS first class in biodegradable cellophane protective sleeve. Made in Salt Lake City, Utah',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:21:05.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
